import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";
import { PortionForm } from "@/components/nutri/PortionForm";

const FIELDS = [["kcal", "Kcal"], ["protein", "Proteine g"], ["carbs", "Carboidrati g"], ["fat", "Grassi g"]];

export const CustomTab = ({ meal, date, onDone }) => {
  const [f, setF] = useState({ name: "", kcal: "", protein: "", carbs: "", fat: "" });
  const [created, setCreated] = useState(null);

  const save = async (e) => {
    e.preventDefault();
    try {
      const body = { name: f.name, ...Object.fromEntries(FIELDS.map(([k]) => [k, Number(f[k]) || 0])) };
      const { data } = await api.post("/nutri/foods/custom", body);
      toast.success("Alimento salvato tra i tuoi preferiti");
      setCreated(data);
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  if (created) return <PortionForm food={created} meal={meal} date={date} source="custom" onDone={onDone} onBack={() => setCreated(null)} />;

  return (
    <form onSubmit={save} className="space-y-4 pt-4" data-testid="custom-food-form">
      <Input data-testid="custom-food-name" required placeholder="Nome alimento" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="h-12" />
      <p className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">Valori per 100 g</p>
      <div className="grid grid-cols-2 gap-3">
        {FIELDS.map(([k, l]) => (
          <Input key={k} data-testid={`custom-food-${k}`} type="number" step="0.1" min="0" required={k === "kcal"} placeholder={l} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
        ))}
      </div>
      <button data-testid="custom-food-save-btn" className="w-full bg-[#98bfa2] py-3 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca]">
        Salva e scegli la quantità
      </button>
    </form>
  );
};
